import { type ComponentPropsWithoutRef, memo } from 'react';

import { CommandEmpty } from '@air/cmdk';

export type ComboboxEmptyProps = ComponentPropsWithoutRef<typeof CommandEmpty>;

export const ComboboxEmpty = memo(({ children, ...restOfProps }: ComboboxEmptyProps) => {
  return (
    <CommandEmpty className="p-2 text-center text-14 text-gray-11" data-testid="COMBOBOX_EMPTY" {...restOfProps}>
      {children}
    </CommandEmpty>
  );
});

ComboboxEmpty.displayName = 'ComboboxEmpty';
